import {
    FLOW_TYPE,
    NOTES_TYPE,
    GOALS,
    PROCESSES,
    SEQUENCE_START,
    BIG_CARD_PADDING,
    BIG_CARD_ELEMENT_LIMIT,
    BIG_CARD_PADDING_OFFSET,
    DECISION_TYPE,
    BIG_CARD_ADDITIONAL_OPTIONS_HEIGHT, GRID_SIZE,
} from '../editor.constants';

export const getIconNameByCellType = (cellType) => {
    switch (cellType) {
    case GOALS.GOAL_SMART_FORM:
    case GOALS.GOAL_WEB_FORM:
    case GOALS.GOAL_INTERNAL_FORM:
        return 'form';
    case GOALS.GOAL_UNLAYER_LANDING_PAGE:
        return 'landingPage';
    case PROCESSES.PROCESS_UNLAYER_EMAIL:
    case PROCESSES.PROCESS_BARD_EMAIL:
        return 'email';
    case PROCESSES.PROCESS_MOVE_OPPORTUNITY:
        return 'opportunity';
    case FLOW_TYPE:
        return 'sequence';
    case NOTES_TYPE:
        return 'note';
    case GOALS.GOAL_EMAIL_CONFIRM:
    case GOALS.GOAL_UNLAYER_EMAIL_CONFIRM:
        return 'emailConfirm';
    default:
        return cellType;
    }
};

export const getIconPathByCellType = (cellType, color = 'neutral') => {
    const iconName = getIconNameByCellType(cellType);

    if (cellType === 'start') {
        return `/resources/funnel/images/svg/cell-icon/${color}/startEmpty.svg`;
    }

    return `/resources/funnel/images/svg/cell-icon/${color}/${iconName}.svg`;
};

export const setCursor = (event, cursor = 'default') => {
    const container = event.target.getStage().container();

    container.style.cursor = cursor;
};

export const getCellTypesHiddenFromBigCard = (isInSequence) => {
    if (isInSequence) return [NOTES_TYPE];

    return [SEQUENCE_START, NOTES_TYPE];
};

export const getBigCardElementHeight = (bigCardCells, isInSequence, isWhen = false) => {
    let elementHeight = isInSequence ? BIG_CARD_PADDING / 2 : BIG_CARD_PADDING_OFFSET;

    const hiddenCells = getCellTypesHiddenFromBigCard(isInSequence);
    const bigCardPreviewCells = bigCardCells.filter((cell) => !hiddenCells.includes(cell.type));

    const previewCellCount = Math.min(bigCardPreviewCells.length, BIG_CARD_ELEMENT_LIMIT);

    elementHeight += previewCellCount * BIG_CARD_PADDING_OFFSET; // number of preview cells

    if (bigCardCells.length === 1 && bigCardCells[0].type === DECISION_TYPE) elementHeight -= BIG_CARD_PADDING * 3; // decision cell

    if (bigCardPreviewCells.length > previewCellCount) elementHeight += BIG_CARD_ADDITIONAL_OPTIONS_HEIGHT; // x more actions

    if (isWhen) elementHeight -= (GRID_SIZE - BIG_CARD_ADDITIONAL_OPTIONS_HEIGHT);

    return elementHeight;
};
